import { Component, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import '../../node_modules/primeng/resources/themes/omega/theme.css';
import '../../node_modules/primeng/resources/primeng.min.css';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {

   constructor(
        private _toastr: ToastsManager,
        private vRef: ViewContainerRef
    ) {
        this._toastr.setRootViewContainerRef(vRef);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts